import { DeviceShadowDTO, UnitStateV2 } from '@eppendorf/vnls-device-service-utils';
import { HasClassName } from '@eppendorf/vnls-react-components';
import { ReactElement } from 'react';

import { ActivityStatusSnapshot } from '$features/monitoring/activity-status/activity-status-snapshot';

export interface ActivityStatusWrapperProps extends HasClassName {
  deviceShadow?: DeviceShadowDTO;
  bordered?: boolean;
  withDateWhenOffline?: boolean;
  fallback?: ReactElement;
}

export function ActivityStatusWrapperSnapshot({
  deviceShadow,
  className,
  bordered,
  withDateWhenOffline = false,
  fallback,
}: ActivityStatusWrapperProps): ReactElement {
  const status = deviceShadow?.activityState;

  if (!status && fallback) {
    return fallback;
  }

  const offlineSince =
    withDateWhenOffline &&
    (deviceShadow?.lastSeenAt || deviceShadow?.shadowUpdatedAt) &&
    status === UnitStateV2.Offline
      ? (deviceShadow?.lastSeenAt ?? deviceShadow?.shadowUpdatedAt)
      : undefined;

  return (
    <ActivityStatusSnapshot
      bordered={bordered}
      offlineSince={offlineSince ?? undefined}
      className={className}
      activityStatus={status}
    />
  );
}
